import React from 'react'
import Link from 'gatsby-link'
import './header.scss'
import logo from './../../../static/icons/autokwix-logo.svg'
import showMenuIcon from './../../../static/icons/hamburger-icon.svg'
const configMenu = [
  {
    label: 'Reviews',
    route: '#reviews'
  },
  {
    label: 'About',
    route: '/about/'
  },
  {
    label: 'Contact',
    route: '/contact/'
  }
];

const Header = () => {
  return (
    <header className="header">
      <div className="header__content">
        <nav className="header__navigation">
          <span role="button" className="header__hamburger" on="tap:sidebar1.toggle" tabIndex="0">
            <img src={showMenuIcon} className="header__mobile-icon" height="32" width="32" alt="Menu hamburger icon" layout="flex-item" />
          </span>
          <div className="header__logo">
            <Link to="/" className="header__logo-link">
              <img height="50" width="200" className="header__logo-img" src={logo} alt="autokwix logo" layout="flex-item" />
            </Link>
          </div>
          <ul className="header__list">
            {
              configMenu.map((item) => {
                return (
                  <li className="header__item" key={item.route}>
                    <Link activeClassName="active" className="header__link" to={item.route}>
                      {item.label}
                    </Link>
                  </li>
                )
              })
            }
          </ul>

          <amp-sidebar id="sidebar1" layout="nodisplay" side="left" style={{ display: 'none' }}>
            <div role="button" aria-label="close sidebar" className="sidebar__close close-sidebar" on="tap:sidebar1.toggle" tabIndex="0">✕</div>
            <ul className="sidebar header__mobile">
              {
                configMenu.map((item) => (
                  <li className="header__mobile-item" key={item.route}>
                    <a className="header__mobile-link" href={item.route}>
                      {item.label}
                    </a>
                  </li>
                ))
              }
            </ul>
          </amp-sidebar>
        </nav>
      </div>
    </header>
  )
};

export default Header


// WEBPACK FOOTER //
// ./src/components/header/Header.js